import { render } from "./person-create.vue?vue&type=template&id=7b8a759e"
import script from "./person-create.vue?vue&type=script&lang=js"
export * from "./person-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__